import React, { FC } from 'react';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import { HeightStyle } from 'components/atoms/input/input';
import { withStylePreferenceConsumer } from 'components/atoms/style-preference-context';
import { BooleanField } from '../fields';
import { EditableProps } from './editable-props';
import { NoValue } from './no-value';

interface Props extends Partial<EditableProps<boolean>> {
  field: BooleanField;
}

const Editor = withStylePreferenceConsumer(styled(Checkbox)`
  height: ${HeightStyle};
  display: flex;
  align-items: center;
  padding: 0 var(--cell-padding);
`);

export const BooleanFieldValue: FC<Props> = ({
  field,
  id,
  editable,
  onChange,
}) =>
  !editable ? (
    field.value == null ? (
      <NoValue />
    ) : (
      <Checkbox checked={field.value} />
    )
  ) : (
    <Editor
      data-cy={`ag-grid.${field.type}.editor`}
      id={id}
      checked={field.value || false}
      onChange={(latest) => !!editable && onChange?.(latest.target.checked)}
    />
  );
